import ApiEndpoint, { ApiResponse } from '../../network/ApiEndpoint'

export interface IsLikedParams {
  company?: string
  game_ident?: string
  description_url?: string
  media_object_slug?: string
}

export const isLikedByUser = async (params: IsLikedParams) => {
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: 'media_object/watch/liked_by_user',
      method: ApiEndpoint.METHODS.GET,
      authenticatable: true,
      params
    })
    return resultResponse?.data?.status
  } catch (e: any) {
    // @ts-ignore
    throw new Error(e.message)
  }
}
